// extracted by mini-css-extract-plugin
export default {"ButtonGroup":"style_ButtonGroup__lqMgw"};